import { Icon } from "@chakra-ui/react";

export const ArrowDownIcon = () => {
  return (
    <Icon viewBox="0 0 16 15" fill={"currentColor"}>
      <path d="M8.83334 1L8.83334 4.08718e-08L6.83334 -4.08718e-08L6.83334 1L8.83334 1ZM7.83334 12.6667L7.12623 13.3738L7.83334 14.0809L8.54045 13.3738L7.83334 12.6667ZM14.3738 7.54044L15.0809 6.83333L13.6667 5.41912L12.9596 6.12623L14.3738 7.54044ZM2.70711 6.12623L2 5.41912L0.585786 6.83333L1.29289 7.54044L2.70711 6.12623ZM6.83334 1L6.83334 12.6667L8.83334 12.6667L8.83334 1L6.83334 1ZM12.9596 6.12623L7.12623 11.9596L8.54045 13.3738L14.3738 7.54044L12.9596 6.12623ZM8.54045 11.9596L2.70711 6.12623L1.29289 7.54044L7.12623 13.3738L8.54045 11.9596Z" />
    </Icon>
  );
};
